import React, { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import FormContainer from "./FormContainer";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Switch } from "@mui/material";
import Typography from "@mui/material/Typography";

export default ({ packageForInspectionSubjects }) => {
  const [subjects, setSubjects] = useState(packageForInspectionSubjects);

  useEffect(() => {
    setSubjects(packageForInspectionSubjects);
  }, [packageForInspectionSubjects]);

  const handleChange = (event) => {
    const subject = subjects.find(
      (subject) => subject.uuid == event.target.name,
    );
    const newSubject = { ...subject, enabled: event.target.checked };
    fetch("/sections/my-account/ajax/cancel_package_for_inspection.php", {
      method: "POST",
      body: JSON.stringify({
        subject: newSubject,
      }),
    })
      .then((r) => {
        return r.json();
      })
      .then((json) => {
        if (!json.error) {
          setSubjects((subjects) => {
            return subjects.map((subject) => {
              if (subject.uuid === event.target.name) {
                return newSubject;
              }
              return subject;
            });
          });
        }
      });
  };

  return (
    <FormContainer>
      <h4>
        <Trans>Picture packages for inspection</Trans>
      </h4>
      <p>
        <Trans>
          You will receive a standard picture package for inspection for each
          of these picture sets.
        </Trans>
      </p>
      <p>
        <Trans>
          If you don't want packages for inspection please switch off the
          slider below
        </Trans>
      </p>

      <FormGroup column>
        {subjects.map((subject) => {
          return (
            <FormControlLabel
              key={subject.uuid}
              control={
                <Switch
                  onChange={handleChange}
                  name={subject.uuid}
                  checked={!!subject.enabled}
                />
              }
              label={
                <>
                  <div>{subject.name}</div>
                  {!subject.enabled && (
                    <Typography
                      variant="caption"
                      color="error.main"
                      sx={{ display: "block", lineHeight: 1, mt: -0.25 }}
                    >
                      <Trans>Package disabled</Trans>
                    </Typography>
                  )}
                </>
              }
            />
          );
        })}
      </FormGroup>
    </FormContainer>
  );
};
